var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('form-area',{ref:"adminForm",staticClass:"flex-box vertical content md",attrs:{"layout":"horizontal","label-col":{ span: 4 },"wrapper-col":{ span: 20 },"items":_vm.items,"entity":_vm.form,"confirm-text":"确定"},on:{"cancel":_vm.cancel,"confirm":_vm.confirm}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }